'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:account:login');
}

var _invoke = require('../invoke');

/**
 * 打开客户端登录界面
 *
 * 1. 客户端不会判断是否已经登录。
 * 需要业务方自己调用 `hbnb.account.getUser` 判断是否已经登录。
 * 2. 用户没有登录直接返回时，客户端不会给出通知。
 * 需要业务方自己监听 `HBNB:pageshow` 事件。
 *
 * 支持版本
 * + iHotel/5.8
 *
 * @memberof account
 * @static
 * @name login
 * @returns {Promise<user>} resolve if login success
 * @example
 *  hbnb.account.login()
 *      .then(function(user) {
 *          user = {
 *              userId: 1234567,
 *              userName: 'name is string',
 *              userToken: 'token is string'
 *          }
 *      })
 */

module.exports = function() {
    var p = new Promise(function(resolve, reject) {
        _invoke('user', 'login', {
            callback: function(user) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('success, user is %j', user, user);
                }
                resolve(user);
            },
            errback: reject
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/account/login.js
// module id = 239
// module chunks = 4